'use client';

import { useEffect } from 'react';

import { continueWithKeycloak } from '~/actions/auth/continue-with-keycloak';

export default function SignInPage() {
  useEffect(() => {
    continueWithKeycloak();
  }, []);

  return null;
}
